import { IconButton, makeStyles } from "@material-ui/core";
import { Field } from "formik";
import * as React from "react";
import { Close as CloseIcon, Search as SearchIcon } from "@material-ui/icons";
import { IParticipant } from "src/common/types";
import { IAdminRoletItem } from "src/modules/Dashboard/AdminRoles/types";
import Suggestion from "../Suggestion";

const useStyles = makeStyles((theme: any) => ({
  selectedWrapper: {
    position: "relative",
    width: 530
  },
  closeButton: {
    color: theme.palette.grey[500],
    position: "absolute",
    right: 8,
    top: 8
  },
  suggestionsWrapper: {
    border: "1px solid #bdbdbd",
    boxShadow: " 0 2px 4px 0 rgba(219, 219, 219, 0.5)",
    display: "block",
    maxWidth: "100%",
    position: "relative",
    width: 530,
    marginBottom: "20px"
  },
  searchIcon: {
    fill: "#bdbdbd",
    fontSize: "1.75rem",
    left: 19,
    position: "absolute",
    top: 12
  },
  searchInput: {
    "&:focus": {
      border: `1px solid ${theme.palette.primary.main}`
    },
    border: "1px solid #e6e6e6",
    display: "block",
    fontSize: "1.8rem",
    lineHeight: "41px",
    margin: -1,
    padding: "0 12px 0 48px",
    width: "calc(100% + 2px)"
  }
}));

interface IProps {
  clearUsernameSelection: () => void;
  currentSelection?: IParticipant | IAdminRoletItem;
  handleUsernameSearch: (val: React.ChangeEvent<HTMLInputElement>) => void;
  handleUsernameSelection: (val: IParticipant) => void;
  mode?: string;
  searchText: string;
  suggestions: IParticipant[];
}

export const SearchNameInput = ({
  clearUsernameSelection,
  currentSelection,
  handleUsernameSearch,
  handleUsernameSelection,
  mode = "create",
  searchText,
  suggestions
}: IProps) => {
  const classes = useStyles();

  return currentSelection ? (
    <>
      <div className={classes.selectedWrapper}>
        {mode !== "edit" && (
          <IconButton className={classes.closeButton} aria-label="clear selection" onClick={clearUsernameSelection}>
            <CloseIcon />
          </IconButton>
        )}
        <Suggestion participant={currentSelection} />
      </div>
    </>
  ) : (
    <div className={classes.suggestionsWrapper}>
      <SearchIcon className={classes.searchIcon} />
      <Field
        name="name"
        className={classes.searchInput}
        value={searchText}
        onChange={handleUsernameSearch}
        placeholder="Search a name"
      />
      <div style={{ position: "absolute", zIndex: 500 }}>
        {suggestions.map((participant: any) => {
          const { id } = participant;
          return <Suggestion onSelection={handleUsernameSelection} key={id} participant={participant} />;
        })}
      </div>
    </div>
  );
};
